module.exports = "/images/ford_logo_small.png?4ad8d4bda9f2e438ba24edf068a43e95";